<template>
  <div class="layout">
    <vue-header/>
    <nuxt class="layout__inner"/>
    <vue-footer/>
  </div>
</template>

<script>
import VueHeader from '~/components/layout/header';
import VueFooter from '~/components/layout/footer';
import { ENVIRONMENT } from '~/utils/consts';

export default {
  name: 'DefaultLayout',
  components: { VueHeader, VueFooter },
  mounted() {
    if (process.env.NODE_ENV !== ENVIRONMENT.DEVELOPMENT) {
      // TODO: Uncomment when chat24 is ready
      // this.$chat24.init();
    }
  },
};
</script>

<style lang="scss" scoped>
.layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  &__inner {
    flex-grow: 1;
  }

  & /deep/ .sidebar__toggle {
    background: map-get($colors, secondary);
  }

  @include mobile {
    /deep/ .sidebar__title {
      background: map-get($colors, secondary);
    }
  }
}
</style>
